import React, {useState} from "react";
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';

import { cancerstat, cancerstat_3 } from "../../../constants";
import ButtonGroup from '@mui/material/ButtonGroup';
//import ButtonsMain from "../../../components/Button/ButtonMain";

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';


export default function CancerActions() {

const [dialogOpen, setdialogOpen] = useState(false);
const handleDialogOpen = () => {setdialogOpen(true);};
const handleDialogClose = () => {setdialogOpen(false);};

const [dialogOpen1, setdialogOpen1] = useState(false);
const handleDialogOpen1 = () => {setdialogOpen1(true);};
const handleDialogClose1 = () => {setdialogOpen1(false);};

const [dialogOpen2, setdialogOpen2] = useState(false);
const handleDialogOpen2 = () => {setdialogOpen2(true);};
const handleDialogClose2 = () => {setdialogOpen2(false);};


const steps = [
    'Collect your sample',
    'DNA sequencing',
    'Bioinformatics, Variant Calling',
    'AI supported filtering & annotating',
    'Link clinical databases (clinvar, HGMD, COSMIC, etc.)',
    'your genetic profile'
  ];

return(
<>      

  
      <ButtonGroup variant="text" color="tertiary" >
                <Button onClick={handleDialogOpen1}  sx={{ color: 'common.black', }}>&nbsp;&nbsp;important read&nbsp;&nbsp;</Button>
                <Button onClick={handleDialogOpen2}  sx={{ color: 'common.black' }}>Cancer Statistics &nbsp;&nbsp;</Button>  
                <Button onClick={handleDialogOpen}  sx={{ color: 'common.black' }}>Counseling &nbsp;&nbsp;</Button>  
      </ButtonGroup>


{/* Dialog */}   

        <Dialog open={dialogOpen} onClose={handleDialogClose} 
                sx={{ '& .MuiDialog-paper': { borderRadius: '16px'}, '& .MuiDialogContent-root': { display: 'flex', flexDirection: 'column', m: 'auto', width: '100%', }, 
                        '& .MuiDialogActions-root': { padding: 0,},  }}>
                <DialogTitle sx={{ bgcolor: 'background.default',}}>
                        <Typography  variant='h4' color='primary' align= 'center' 
                                sx={{p:4, color: 'text.brown', fontFamily: 'Poppins', fontWeight: '500'}} >BOOK A COUNSELING MEETING</Typography>
                </DialogTitle>
                <DialogContent sx={{ bgcolor: 'background.default', color: 'common.white' }}>
                        
                        

                </DialogContent>
                <DialogActions sx={{ bgcolor: 'background.default'}}>
                
                                <Button onClick={handleDialogClose} sx={{ p:2, mr: 4, color: 'text.brown'}}>BACK</Button>
        
                </DialogActions>
        </Dialog>

{/* Dialog 1 */}
                       
        <Dialog open={dialogOpen1} onClose={handleDialogClose1} maxWidth='md'
                        sx={{ '& .MuiDialog-paper': { borderRadius: '16px'}, '& .MuiDialogContent-root': { display: 'flex', flexDirection: 'column', m: 'auto', 
                        width: 'fit-content',}, '& .MuiDialogActions-root': { padding: 2,}, }}>
                <DialogTitle sx={{ bgcolor: 'background.default'}}>
                        <Typography  variant='h4' align= 'center' sx={{p:4, color: 'text.brown', fontWeight: '500'}} >YOUR GENETIC SIGNATURE</Typography>
                </DialogTitle>
                
                <DialogContent sx={{ bgcolor: 'background.default'}}>
                        
                        <DialogContentText>
                        
                        Genetic variant analysis requires a series of steps which we ran through for you:  <br />


                <Grid container spacing={1} sx={{ml:0, mb:8 }}>

                        <Grid item xs={12} sx={{ mt: 8, ml:0, }}>
                        <Box sx={{ width: '100%', mt:4, }}>
                                <Stepper activeStep={steps.length} alternativeLabel >
                                {steps.map((label) => (
                                        <Step key={label} sx={{ }}>
                                        <StepLabel ><Typography variant='h5' color='primary.light' sx={{ fontWeight: '400', color: 'text.brown'}}>{label}</Typography></StepLabel>
                                        </Step>
                                ))}
                                </Stepper>
                                </Box>
                        </Grid>
                        </Grid>

                Genetic variants are differences in DNA between people. 
                These variants make you unique and are essential for precision health best practices. 
                <br /><br />Some variants may increase the risk of developing certain health conditions. 
                However, not everyone with a risk variant will develop these health conditions. 
                Since families share DNA, having a family history of a condition can increase risk.<br /><br />
                This test is not intended to diagnose a disease, determine medical treatment, or 
                tell the user anything about their current state of health. 
                This test is intended to provide users with their genetic information to inform lifestyle decisions and conversations with their doctor 
                or other health care professional.<br /><br />

                This test is not a substitute for visits to your doctor or other health care professional. 
                As soon as your individual genomic signature is available, you should book a counseling meeting with our experts or your doctor to discuss the results.
                <br /><br /><br /><br />

{/*
                <Typography variant="h4" color='text.brown' gutterBottom align='left' sx={{ml:4, mb:4  }}> Explanation: </Typography>

        <Grid container>
        
        <Grid item xs={1} sx={{ ml:4}}>
                <Avatar sx={{ bgcolor: 'traffic.green', color: 'grey.600' }}><CheckIcon /></Avatar>
        </Grid>
        <Grid item xs={9} sx={{ }}>
                <Typography color='text.brown' gutterBottom align='left' sx={{ p:1, ml:1 }}> 
                No negative associations based on the genotype for the evaluated condition. <br /><br /> </Typography>
        </Grid>
        
        </Grid>

        <Grid container>
        
        <Grid item xs={1} sx={{ ml:4}}>
                <Avatar sx={{ bgcolor: 'traffic.red', color: 'grey.300'}}><PriorityHighIcon /></Avatar>
        </Grid>
        <Grid item xs={10} sx={{ }}>
                <Typography  color='text.brown' gutterBottom align='left' sx={{ p:1, ml:1 }}> 
                You may have a variant potentially associated with an increased risk for the evaluated condition. </Typography>
        </Grid>
        
        </Grid>
*/}
        </DialogContentText>

        

        </DialogContent>
        <DialogActions  sx={{ bgcolor: 'background.default'}}>
                <Button onClick={handleDialogClose1} sx={{ p:2, mr: 2, color: 'text.brown'}}>BACK</Button>
        </DialogActions>
     </Dialog>

{/* Dialog 2 */}

        <Dialog open={dialogOpen2} onClose={handleDialogClose2} maxWidth='md'
                sx={{ '& .MuiDialog-paper': { borderRadius: '16px'}, '& .MuiDialogContent-root': { display: 'flex', flexDirection: 'column', m: 'auto', p:4,  width: '100%', }, 
                     '& .MuiDialogActions-root': { padding: 0,},  }}>
        
             <DialogTitle sx={{ bgcolor: 'background.default',}}>
                   <Typography  variant='h4' color='primary' align= 'center' 
                                 sx={{p:4, color: 'text.brown', fontFamily: 'Poppins', fontWeight: '500'}} >Cancer - Statistics of 2023</Typography>
             </DialogTitle>
        
             <DialogContent sx={{ bgcolor: 'background.default', color: 'text.brown' }}>
          
             
             Cancer Statistics of 2023 shows that some cancer types are more frequent than others:
             <br /><br /><br />
             <img 
            src={cancerstat}
            width="100%"
            height="auto"
            alt="parallax"
          /> <br /><br /><br />

Trends in cancer mortality:
             <br /><br /><br />
             <img 
            src={cancerstat_3}
            width="100%"
            height="auto"
            alt="parallax"
 
          />

             <br /><br /><br />
             Source: &nbsp;&nbsp;https://pubmed.ncbi.nlm.nih.gov/36633525/
       

              </DialogContent>
              <DialogActions sx={{ bgcolor: 'background.default'}}>
                                
                  <Button onClick={handleDialogClose2} sx={{ p:2, mr: 4, color: 'text.brown'}}>BACK</Button>
                  
               </DialogActions>
        </Dialog>

</>
)}